import { render, staticRenderFns } from "./PhonelinkLockOutlined.vue?vue&type=template&id=230d7eb8&"
import script from "./PhonelinkLockOutlined.vue?vue&type=script&lang=js&"
export * from "./PhonelinkLockOutlined.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports